import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ChangePasswordComponent } from '@ebw-monorepo/login';
import { ConfigSidebarService } from '@ebw-monorepo/map';
import moment from 'moment';
import { filter } from 'rxjs';
import { API_URLS, ApiUrlService } from '../../../../../../libs/ng-components/utils/src/lib/services/api-url.service';
import { AuthService } from '../../services/auth.service';
import { UserManagerService } from '../../services/user-manager.service';

@Component({
  selector: 'ebw-monorepo-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
  public userId: string;
  public groupIds: string;
  public userInfo: any;
  public profilePageRoute = ['/home/profile'];
  public displayedName = '';

  public urlPassword = '';

  // true mentre e' in corso il logout innescato dall'annullamento del cambio password obbligatorio:
  // evita che la subscription su router.events riapra la modale sulla navigazione verso /login
  private isLoggingOut = false;

  constructor(
    private userManagerService: UserManagerService,
    private authService: AuthService,
    private apiUrlSrv: ApiUrlService,
    private configSidebarSrv: ConfigSidebarService,
    private dialogRef: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userId = this.userManagerService.userId;
    this.groupIds = this.userManagerService.userInfo.groups.map((group) => group.id);
    this.userInfo = this.userManagerService.userInfo;

    const { name, username, surname } = this.userInfo;
    this.displayedName = this.getDisplayedName(name, surname, username);

    this.urlPassword = this.apiUrlSrv.createUrl(API_URLS.USER.CHANGE_PASSWORD);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe({
      next: () =>
        !this.isLoggingOut &&
        (this.userInfo?.to_confirm == 1 || this.isPasswordExpired()) &&
        this.changePasswordAfterReset()
    });

    if (this.userInfo.to_confirm == 1 || this.isPasswordExpired()) {
      this.changePasswordAfterReset();
    }
  }

  isPasswordExpired(): boolean {
    return !!this.userInfo?.expired && moment(this.userInfo.expired).isBefore();
  }

  changePasswordAfterReset() {
    // se sono superuser1 o superuser2 non devo modificare la passowrd
    if (this.userInfo.username == 'superuser1' || this.userInfo.username == 'superuser2') {
      return;
    }
    this.dialogRef
      .open(ChangePasswordComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: '30%',
        data: {
          user_id: this.userId,
          url: this.urlPassword,
          expiredDate: this.userInfo?.expired,
          to_confirm: this.userInfo.to_confirm
        }
      })
      .afterClosed()
      .subscribe((val) => {
        // Se la risposta della modale è positiva, imposto il valore a 0 per preverire aperture fino al prossimo allineamento dati con il server
        if (val == 'CONFIRM') {
          this.userManagerService.userInfo.to_confirm = 0;
          this.userInfo.to_confirm = 0;
          this.userManagerService.userInfo.expired = null;
          this.userInfo.expired = null;
        } else {
          // l'utente ha annullato il cambio password obbligatorio: lo slogghiamo, al prossimo
          // accesso questo stesso form ricomparirà finché non completerà il cambio
          this.isLoggingOut = true;
          this.authService.logout();
        }
      });
  }

  getDisplayedName = (name: string, surname: string, username: string) => {
    // Se esistono sia nome sia cognome prendo le loro inziali
    if (name && surname) {
      return `${name[0]}${surname[0]}`;
    }
    // altrimenti pesco le prime 2 dall'username
    return username.substring(0, 2);
  };

  public logout(event: MouseEvent) {
    event.stopPropagation();
    this.authService.logout();
    this.dialogRef.closeAll();
    this.configSidebarSrv.removeConfiguration();
  }
}
